"use client";
import { useEffect } from "react";

export default function AutoDailyReload() {
  useEffect(() => {
    const clearCaches = async () => {
      try {
        if ("indexedDB" in window) {
          const dbs = await indexedDB.databases();
          await Promise.all(dbs.map((db) => db.name && indexedDB.deleteDatabase(db.name)));
        }

        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((n) => caches.delete(n)));
        }

        if ("serviceWorker" in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map((r) => r.unregister()));
        }

        console.log("[AutoReload] All caches cleared ✅");
      } catch (err) {
        console.error("[AutoReload] Cache clearing failed:", err);
      }
    };

    const checkReload = async () => {
      setTimeout(async () => {
        await clearCaches();
        window.location.reload(true);
      }, 20 * 1000);
    };

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") checkReload();
    });

    return () => document.removeEventListener("visibilitychange", checkReload);
  }, []);

  return null;
}
